import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class SessionStorageService {
  private appTokenKey: string = 'token';

  constructor() {}

  setObject(item: string, objectItem: any) {
    localStorage.setItem(item, JSON.stringify(objectItem));
  }

  getObject(item: string): any {
    let itemObjeto: any = localStorage.getItem(item);
    if (itemObjeto) itemObjeto = JSON.parse(itemObjeto);

    return itemObjeto || [];
  }

  removeObject(item: string) {
    localStorage.removeItem(item);
  }

  inserirTokenAplicacao(token: string): void {
    sessionStorage.setItem(this.appTokenKey, token);
  }

  limparTokenAplicacao(): void {
    sessionStorage.removeItem(this.appTokenKey);
  }

  buscarTokenAplicacao(): string {
    return sessionStorage.getItem(this.appTokenKey);
  }
}
